import Show from '../show'

function WorkflowDashboard() {
  return (
    <Show
      title="Workflow Dashboard"
      dashboardKey="workflow_dashboards"
      showYear={false}
      showAccounts={false}
      showEmployee={false}
      showVendor={false}
      showAnalytics={false}
    />
  )
}

export default WorkflowDashboard